import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function acceptGalleryRequest(requestId) {
  return fetchWrapper.post(`${config.apis.api.url}/request/access/gallery/accept/${requestId}`, {
    injectToken: true
  });
}

function denyGalleryRequest(requestId, reason) {
  return fetchWrapper.post(`${config.apis.api.url}/request/access/gallery/reject/${requestId}`, {
    injectToken: true,
    body: {
      reason
    }
  });
}

function acceptArtworkRequest(requestId) {
  return fetchWrapper.post(`${config.apis.api.url}/draft/approve/${requestId}`, {
    injectToken: true,
  });
}

function requestChangesArtworkRequestAndNotifyChanges(requestId, draftChanges) {
  return fetchWrapper.post(`${config.apis.api.url}/draft/request-changes/${requestId}`, {
    injectToken: true,
    body: {
      draft_changes: draftChanges
    }
  });
}

function rejectArtworkRequestAndNotifyChanges(requestId, draftChanges) {
  return fetchWrapper.post(`${config.apis.api.url}/draft/reject/${requestId}`, {
    injectToken: true,
    body: {
      draft_changes: draftChanges
    }
  });
}

function acceptLimitedEditionRequest(requestId) {
  return fetchWrapper.post(`${config.apis.api.url}/inventory/limited-editions/${requestId}/approve`, {
    injectToken: true,
  });
}

function requestChangesLimitedEditionRequestAndNotifyChanges(requestId, reason) {
  return fetchWrapper.post(`${config.apis.api.url}/inventory/limited-editions/${requestId}/request-changes`, {
    injectToken: true,
    body: {
      reason
    }
  });
}

function rejectLimitedEditionRequestAndNotifyChanges(requestId, reason) {
  return fetchWrapper.post(`${config.apis.api.url}/inventory/limited-editions/${requestId}/reject`, {
    injectToken: true,
    body: {
      reason
    }
  });
}

const AdminService = {
  acceptGalleryRequest,
  requestChangesLimitedEditionRequestAndNotifyChanges,
  denyGalleryRequest,
  acceptArtworkRequest,
  requestChangesArtworkRequestAndNotifyChanges,
  rejectArtworkRequestAndNotifyChanges,
  acceptLimitedEditionRequest,
  rejectLimitedEditionRequestAndNotifyChanges
};

export default AdminService;